module.exports = __webpack_public_path__ + "static/img/wi.abf36f74.webp";